const postgraduateDegreeMap = {
  "M.Tech / ME": {
    "Programming & Software Foundations": [
      "Data Structures",
      "OOP",
      "Operating Systems",
      "C / C++ / Python",
    ],
    "Mathematics & Applied Logic": [
      "Engineering Mathematics",
      "Statistics",
      "Linear Algebra",
    ],
    "AI & Data": [
      "Artificial Intelligence",
      "Machine Learning",
      "Data Science",
      "Neural Networks",
    ],
    "Cybersecurity & Blockchain": [
      "Cryptography",
      "Cyber Laws",
      "Information Security",
    ],
    "Mechanical/Civil/Electrical Basics": [
      "Mechanical Core Subjects",
      "Civil Core Subjects",
      "Electrical Core Subjects",
    ],
    "Automation & Robotics": ["Robotics", "Mechatronics"],
    "Design & Manufacturing": ["CAD", "CAM", "Product Design"],
    "Aerospace & Aeronautics": ["Aerodynamics", "Propulsion"],
  },

  "M.Sc.": {
    "Foundational Sciences": ["Mathematics", "Physics", "Chemistry", "Biology"],
    "Lab & Experimental": ["Spectroscopy", "Microscopy", "Practicals"],
    "Environmental Sciences": [
      "Environmental Studies",
      "Geology",
      "Oceanography",
    ],
    "Biological Sciences": ["Biotechnology", "Microbiology", "Bioinformatics"],
    Specializations: ["Astrophysics", "Marine Ecology", "Zoology"],
  },

  "M.A.": {
    Humanities: ["Literature", "History", "Philosophy", "Media Studies"],
    "Social Sciences": ["Sociology", "Psychology", "Political Science"],
    "Public Policy": ["Government", "Policy Analysis", "Ethics"],
  },

  "M.Com": {
    "Core Commerce": ["Accounting", "Taxation", "Business Laws"],
    "Finance & Banking": ["Risk Management", "International Banking"],
    "Auditing & BI": ["Auditing", "Forensics", "ERP"],
    "Business Studies": ["Human Resource Management", "Strategy", "E-Commerce"],
  },

  "MBA / PGDM": {
    HRM: ["Recruitment", "Organizational Development", "Labor Laws"],
    Marketing: ["Branding", "Digital Marketing"],
    Analytics: ["Business Intelligence", "SQL", "Tableau", "Python"],
    Sales: ["CRM", "B2B / B2C", "Channel Management"],
    Operations: ["Supply Chain", "Quality Management", "Project Management"],
    "Product Management": ["Design Thinking", "Agile"],
    Strategy: ["Mergers & Acquisitions", "Risk", "Corporate Strategy"],
    Leadership: ["Change Management", "Team Building"],
  },

  MCA: {
    "Software Development": ["Java", "Python", "Architecture", "Testing"],
    "Web & Mobile": ["React", "Flutter", "HTML", "CSS"],
    "Cloud Computing": ["AWS", "Azure", "IaaS"],
    Cybersecurity: ["Hacking", "Cryptography", "Malware"],
    Networking: ["Routing", "Protocols", "Administration"],
    IT: ["DBMS", "IT Governance"],
  },

  "M.Des": {
    "Product Design": ["Prototyping", "CAD", "Ergonomics"],
    "UX Design": ["User Research", "Wireframes"],
    Animation: ["2D / 3D", "Blender", "Storyboarding"],
    "Industrial Design": ["Aesthetic Design", "Functional Design"],
    Fashion: ["Garments", "Textiles", "Trends"],
    "Graphic Design": ["Typography", "Adobe Tools", "Figma"],
    "Game Design": ["Game Mechanics", "Storytelling"],
  },
};

export { postgraduateDegreeMap };
